<ng-container *ngIf="!isDeliveryConfirmation">
  <div *ngIf="deliveryCurrent" class="basket-confirm">

    <app-delivery-list
      [deliveryCurrent]="deliveryCurrent"
      [deliveryList]="deliveryList"
      [wars]="wars"
      (deliveryChange)="switchesDeliveryType($event)"
    />

    <div class="del-type">
      <div class="del-type-comment pickup"
           [innerHTML]="deliveryCurrent.comment"
      ></div>

      <div class="del-type-comment pickup">
        {{ deliveryCurrent.address }}
      </div>

      <div *ngIf="deliveryCurrent.working_details.will_be_transfer" class="del-type-date-limited">
        <div>
          Дати відправлення обмежені в зв'язку з переміщенням з іншого складу
        </div>
      </div>

      <div *ngIf="deliveryCurrent.allow_delivery_dates" class="del-type-date">
        <label>
          Дата коли заберете замовлення
        </label>
        <div *ngIf="dozakazDate" class="del-type-date-container">
          <small>Дозамовлення на дату: {{ dozakazDate }}</small>
          <ng-container *ngIf="dozakazDate === ''">
            <label *ngIf="!deliveryCurrent.allow_delivery_dates" class="alert">
              По прибуттю товару
            </label>
          </ng-container>
        </div>
        <div *ngIf="!dozakazDate">
          <select
            #scrollInputRef
            [class.border-wrong]="wrongDeliveryDates"
            [(ngModel)]="deliveryDate"
            (change)="changingValueDeliveryDate()"
          >
            <option value="-1">
              Вкажіть дату самовивозу
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryDates">Вкажіть дату самовивозу</span>
        </div>
      </div>

      <div *ngIf="separateOrders && deliveryCurrent?.delivery_dates_zak?.length" class="del-type-date">
        <label>
          Дата відправки переміщення з іншого складу
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliverySeparate"
            [(ngModel)]="deliverySeparate"
            (change)="changingValueDeliverySeparate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates_zak" [value]="date">
              {{ date }}
            </option>
          </select>
          <span *ngIf="wrongDeliverySeparate" class="status-error">Вкажіть дату відправлення</span>
        </div>
      </div>
      <span *ngIf="showMessageOtgrujaem" class="message-otgrujaem">Включено відвантаження без оплати</span>
      <div class="del-type-user-comment">
        <label>Коментар до замовлення</label>
        <div>
          <textarea [(ngModel)]="deliveryComment"></textarea>
        </div>
      </div>

      <div class="del-type-send">
        <a routerLink="/basket">Редагувати замовлення</a>
        <div class="del-type-send-button">
          <app-order-in-progress-message [show]="showOrderInProgressMessage"/>
          <button class="button" [disabled]="isSendingPayment" (click)="sendPayment()">Відправити</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-message-delivery-brojko-confirm [deliveryCurrent]="deliveryCurrent"/>

